import { lazy, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import _ from 'lodash';
import { Pagination } from '../Pagination/Pagination';
import { CommonGrid, TopContainer } from '../../layouts';
import { paginatedProductSelectors } from '../../redux/slicers/admin/paginatedProductSlicer';
import { paginatedRoomsSelectors } from '../../redux/slicers/admin/paginatedRooms';
import { texturesSelectors } from '../../redux/slicers/texturesSlicer';
import { myprojectsSelectors } from '../../redux/slicers/my-projects/myProjectsSlicer';
import { collectionsSelectors } from '../../redux/slicers/collectionsSlicer';
import { myRenderPreviewSelectors } from '../../redux/slicers/render_preview/myRenderPreviewSlice';
import styles from './SearchResult.module.scss';
import { TeamMembersFilter } from '../TeamMembersFilter/TeamMembersFilter';
import { previewsFilter, rendersFilter } from '../../helpers/configureHelper';
import { Outlet, Route, Routes, useLocation, useParams, useSearchParams } from 'react-router-dom';
import {
  ADMIN_MY_PRODUCTS_3DMODAL,
  ADMIN_MY_PRODUCTS_3DMODAL_EACH,
  ADMIN_MY_PRODUCTS_3DMODAL_V2,
  ADMIN_MY_PRODUCTS_ROOMS,
  ADMIN_MY_PRODUCTS_ROOMS_DETAILS,
  ADMIN_MY_PRODUCTS_ROOMS_V2,
  ADMIN_MY_PRODUCTS_TEXTURE,
  ADMIN_MY_PRODUCTS_TEXTURE_EDIT,
  ADMIN_MY_PRODUCTS_TEXTURE_UPLOAD,
  ADMIN_MY_PRODUCTS_TEXTURE_V2,
  ADMIN_MY_PRODUCTS_UPLOADS,
  ADMIN_MY_PRODUCTS_UPLOADS_MOVE_TO_TEXTURE,
  ADMIN_MY_PRODUCTS_UPLOADS_V2,
  ADMIN_MY_PROJECTS,
  ADMIN_MY_PROPS,
  ADMIN_MY_ROOMS_PARAMS,
  ADMIN_NEW_PROJECT,
  AUTOMATION_ROUTE,
  AUTOMATION_ROUTE_V2,
  COLLECTIONS_ROUTE,
  COLLECTION_ID,
  INSPIRATION_ROUTE,
  MY_FILES_SHARED_FILES_ROUTE,
  MY_PRODUCTS_ROUTE,
  MY_PROJECTS_ROUTE,
  MY_TEAM_TEXTURE,
  NEW_DESIGN_ROUTE,
  NEW_PROJECTS_ROUTE,
  PRODUCT_CONFIGURATORS_ROUTE,
  PRODUCT_CONFIGURATORS_ROUTE_V2,
  PRODUCT_RENDER,
  PRODUCT_WEB_EXPERIENCE_PUBLIC,
  PROJECT_RENDER,
  PROPS_ROUTE,
  PROPS_ROUTE_V2,
  RECENT_DESIGNS_ROUTE,
  RENDERS_PREVIEWS_ROUTE,
  RENDERS_PREVIEWS_ROUTE_V2,
  RENDER_DETAILS,
  RENDER_DETAILS_ROUTE_PATH,
  RENDER_DETAILS_ROUTE_PATH_V2,
  RENDER_DETAILS_V2,
  ROOMS_ROUTE,
  ROOM_RENDER,
  SHARED_FILES_ROUTE,
  TEMPLATES_DETAILS,
  TEMPLATES_DETAILS_ROUTE_PATH,
  TEMPLATES_DETAILS_ROUTE_PATH_V2,
  TEMPLATES_ROUTE,
  TEMPLATES_ROUTE_V2,
} from '../../constants/routePathConstants';
import { useUserContext } from '../../contexts/UserContext';
import { sharedFilesPageSelectors } from '../../redux/slicers/sharedFilesPageSlicer';
import { TeamMembersSharedFilesFilter } from '../../common/TeamMembersSharedFilesFilter';
import MyProducts3dModel from '../../screens/MyProducts3dModel';
import MyRooms from '../../screens/MyRooms';
import MyProductsTextures from '../../screens/MyProductsTextures';
import MyProductsUploads from '../../screens/MyProductsUploads';
import MyProjects from '../../screens/MyProjects';
import RendersPreviews from '../../screens/RendersPreviews';
import MyProps from '../../screens/MyProps';
import Collections from '../../screens/Collections';
import SharedFiles from '../../screens/SharedFiles';
import { GlobalSearchTagsFilter } from '../../common/GlobalFilter';
import { selectSearchValue } from '../../redux/slicers/search/searchSlicer';
import PageTitle from '../../common/PageTitle';
import RenderDetails from '../../screens/RenderDetails';
import TemplatesDetails from '../../screens/TemplatesDetails';
import { ADMIN_MY_PROJECTS_V2, ADMIN_MY_PROPS_V2 } from "../../config/constant/routePathConstant";
import FilterSideModalButton from "../../common/FilterSideModalButton";
import { paginatedAutomationSelectors } from "../../redux/slicers/admin/paginatedAutomation";
import { paginatedConfiguratorsSelectors } from "../../redux/slicers/admin/paginatedConfigurators";
import { PERMISSION } from "../../constants/permissionConstants";
import { useStaticPermissions } from "../../hooks/usePermissions";
import { selectHasAutomationsData } from "../../redux/slicers/subscriptionSlicer";
const Automation = lazy(() => import('../../screens/Automation'));
const ProductConfigurators = lazy(() => import('../../screens/ProductConfigurators'));
const Configurators = lazy(() => import('../../screens/Configurators'));

const TAB = {
  MODEL_3D: 'MODEL_3D',
  ROOM: 'ROOM',
  TEXTURE: 'TEXTURE',
  UPLOAD: 'UPLOAD',
  PROJECT: 'PROJECT',
  IMAGES: 'IMAGES',
  PREVIEW: 'PREVIEW',
  TEMPLATE: 'TEMPLATE',
  PROP: 'PROP',
  COLLECTION: 'COLLECTION',
  SHARED: 'SHARED',
  AUTOMATION: 'AUTOMATION',
  CONFIGURATOR: 'CONFIGURATOR',
  PRODUCT_CONFIGURATOR: 'PRODUCT_CONFIGURATOR',
};

const getDefaultTab = (pathname, params, isGuestUser = null) => {
  const map = {
    [MY_PRODUCTS_ROUTE]: TAB.MODEL_3D,
    [MY_PROJECTS_ROUTE]: TAB.PROJECT,
    [RENDERS_PREVIEWS_ROUTE]: TAB.IMAGES,
    [RENDERS_PREVIEWS_ROUTE_V2]: TAB.IMAGES,
    [NEW_DESIGN_ROUTE]: TAB.IMAGES,
    [ROOMS_ROUTE]: TAB.ROOM,
    [TEMPLATES_ROUTE]: TAB.TEMPLATE,
    [TEMPLATES_ROUTE_V2]: TAB.TEMPLATE,
    [TEMPLATES_DETAILS_ROUTE_PATH]: TAB.TEMPLATE,
    [TEMPLATES_DETAILS_ROUTE_PATH_V2]: TAB.TEMPLATE,
    [PROPS_ROUTE]: TAB.PROP,
    [PROPS_ROUTE_V2]: TAB.PROP,
    [COLLECTIONS_ROUTE]: TAB.COLLECTION,
    [COLLECTION_ID]: TAB.COLLECTION,
    [RENDER_DETAILS]: TAB.IMAGES,
    [RENDER_DETAILS_ROUTE_PATH]: TAB.IMAGES,
    [RENDER_DETAILS_V2]: TAB.IMAGES,
    [RENDER_DETAILS_ROUTE_PATH_V2]: TAB.IMAGES,
    [ROOM_RENDER]: TAB.ROOM,
    [NEW_PROJECTS_ROUTE]: TAB.ROOM,
    [PRODUCT_RENDER]: TAB.PROP,
    [ADMIN_MY_PROJECTS]: TAB.PROJECT,
    [ADMIN_MY_PROJECTS_V2]: TAB.PROJECT,
    [ADMIN_NEW_PROJECT]: TAB.PROJECT,
    [ADMIN_MY_PROPS]: TAB.PROP,
    [ADMIN_MY_PROPS_V2]: TAB.PROP,
    [ADMIN_MY_PRODUCTS_3DMODAL]: TAB.MODEL_3D,
    [ADMIN_MY_PRODUCTS_3DMODAL_V2]: TAB.MODEL_3D,
    [ADMIN_MY_PRODUCTS_ROOMS]: TAB.ROOM,
    [ADMIN_MY_PRODUCTS_ROOMS_V2]: TAB.ROOM,
    [ADMIN_MY_PRODUCTS_ROOMS_DETAILS]: TAB.ROOM,
    [ADMIN_MY_PRODUCTS_TEXTURE]: TAB.TEXTURE,
    [ADMIN_MY_PRODUCTS_TEXTURE_V2]: TAB.TEXTURE,
    [ADMIN_MY_PRODUCTS_TEXTURE_EDIT]: TAB.TEXTURE,
    [ADMIN_MY_PRODUCTS_TEXTURE_UPLOAD]: TAB.TEXTURE,
    [ADMIN_MY_PRODUCTS_UPLOADS]: TAB.UPLOAD,
    [ADMIN_MY_PRODUCTS_UPLOADS_V2]: TAB.UPLOAD,
    [ADMIN_MY_PRODUCTS_UPLOADS_MOVE_TO_TEXTURE]: TAB.UPLOAD,
    [ADMIN_MY_PRODUCTS_3DMODAL_EACH]: TAB.MODEL_3D,
    [INSPIRATION_ROUTE]: TAB.TEMPLATE,
    [RECENT_DESIGNS_ROUTE]: TAB.PROJECT,
    [MY_TEAM_TEXTURE]: TAB.TEXTURE,
    [SHARED_FILES_ROUTE]: TAB.SHARED,
    [MY_FILES_SHARED_FILES_ROUTE]: TAB.SHARED,
    [AUTOMATION_ROUTE]: TAB?.AUTOMATION,
    [AUTOMATION_ROUTE_V2]: TAB?.AUTOMATION,
    [PRODUCT_CONFIGURATORS_ROUTE]: TAB?.PRODUCT_CONFIGURATOR,
    [PRODUCT_CONFIGURATORS_ROUTE_V2]: TAB?.PRODUCT_CONFIGURATOR,
  };

  const searchParams = new URLSearchParams(location.search);
  const activeTab = searchParams.get('sTab');

  if (activeTab) {
    return TAB[activeTab.toUpperCase()] || TAB.MODEL_3D;
  }


  const key = Object.keys(map).find((route) => {
    let routeUrl = route;
    Object.keys(params).forEach((key) => {
      routeUrl = routeUrl.replace(`:${key}`, params[key]);
    });

    return routeUrl === pathname;
  });

  return isGuestUser?.() ? map[key] || TAB.PROJECT : map[key] || TAB.MODEL_3D;
};

const TAB_CONFIG = {
  [TAB.MODEL_3D]: {
    Component: MyProducts3dModel,
    selectors: paginatedProductSelectors,
    name: 'My Models',
  },
  [TAB.ROOM]: {
    Component: MyRooms,
    selectors: paginatedRoomsSelectors,
    name: 'My Rooms',
  },
  [TAB.TEXTURE]: {
    Component: MyProductsTextures,
    selectors: texturesSelectors,
    name: 'Textures',
  },
  [TAB.UPLOAD]: {
    Component: MyProductsUploads,
    selectors: texturesSelectors,
    name: 'Custom Maps',
  },
  [TAB.PROJECT]: {
    Component: MyProjects,
    selectors: myprojectsSelectors,
    name: 'Projects',
    canGuestUserAccess: true,
  },
  [TAB.IMAGES]: {
    Component: RendersPreviews,
    selectors: myRenderPreviewSelectors,
    name: 'Images',
    canGuestUserAccess: true,
    props: {
      defaultFilterBy: rendersFilter,
    },
  },
  [TAB.PREVIEW]: {
    Component: RendersPreviews,
    selectors: myRenderPreviewSelectors,
    name: 'Previews',
    canGuestUserAccess: true,
    props: {
      defaultFilterBy: previewsFilter,
    },
  },
  [TAB.TEMPLATE]: {
    Component: MyRooms,
    selectors: paginatedRoomsSelectors,
    name: 'Templates',
  },
  [TAB.PROP]: {
    Component: MyProps,
    selectors: paginatedProductSelectors,
    name: 'Props',
  },
  [TAB.COLLECTION]: {
    Component: Collections,
    selectors: collectionsSelectors,
    name: 'Collections',
  },
  [TAB.SHARED]: {
    Component: SharedFiles,
    name: 'Shared',
    selectors: sharedFilesPageSelectors,
  },
  [TAB?.AUTOMATION]: {
    Component: Automation,
    selectors: paginatedAutomationSelectors,
    name: 'Automation',
  },
  [TAB?.CONFIGURATOR]: {
    Component:Configurators,
    name: 'Configurator',
    selectors: paginatedConfiguratorsSelectors,
  },
  [TAB?.PRODUCT_CONFIGURATOR]: {
    Component: ProductConfigurators,
    name: 'Product Configurator',
    selectors: paginatedConfiguratorsSelectors,
  },
};

export default function SearchResult() {
  let TABClone = { ...TAB }
  const { hasPermission } = useStaticPermissions();
  const hasAutomationData = useSelector(selectHasAutomationsData);
  const searchVal = useSelector(selectSearchValue);
  const location = useLocation();
  const params = useParams();
  const { currentUser, isGuestUser } = useUserContext();

  const defaultTab = useMemo(() => {
    return getDefaultTab(location.pathname, params, isGuestUser);
  }, []);
  // const [activeTab, setActiveTab] = useState(defaultTab);
  const [searchParams, setSearchParams] = useSearchParams()
  const activeTab = searchParams.get('sTab')?.toUpperCase() || defaultTab;

  const setActiveTab = (tab) => {
    searchParams.set('sTab', tab.toLowerCase());
    setSearchParams(searchParams)
  }

  const tabConfig = TAB_CONFIG[activeTab];
  const { Component, selectors, props } = tabConfig;

  const loading = useSelector(selectors.selectLoading);
  const total = useSelector(selectors.selectTotal);
  const list = useSelector(selectors.selectList);

  const isGenericTab = activeTab !== TAB.PROP && activeTab !== TAB.TEMPLATE;
  const doNotIncludeCreatedBy = activeTab !== TAB.MODEL_3D && activeTab !== TAB.ROOM
  const teamFilterTab = [TAB.SHARED, TAB.MODEL_3D, TAB.ROOM, TAB.TEMPLATE, TAB.PROP, TAB.SHARED];
  const isSharedFilesTab = teamFilterTab.includes(activeTab);

  useEffect(() => {
    manageTabOption()
  }, [hasAutomationData , currentUser?.organization, currentUser?.permissions_list])

  const manageTabOption = () => {
    if (!hasPermission(PERMISSION?.CONFIGURATORS)) {
      delete TABClone?.CONFIGURATOR
    }
    if (!hasPermission(PERMISSION?.PRODUCT_CONFIGURATORS)) {
      delete TABClone?.PRODUCT_CONFIGURATOR
    }
    if (!hasAutomationData && !hasPermission(PERMISSION?.CAN_CREATE_AUTOMATION) ) {
      delete TABClone?.AUTOMATION
    } 

    if(isGuestUser()) {
      Object.keys(TAB_CONFIG).forEach(key => {
        if(!TAB_CONFIG[key]?.canGuestUserAccess) {
          delete TABClone?.[key]
        }
      });
    }

    return TABClone
  }

  return (
    <>
      <CommonGrid
        className="searchPgHeader pb-0"
        disableNoDataText
        hiddenTab
        hasData={list.length > 0 || loading}
        topContainer={
          <TopContainer
            title={<PageTitle title={'Search results'} total={total} search={searchVal} />}
            buttonArea={
              <div className="filter_container mb-0">
                <FilterSideModalButton showTeamMemberFilter={!isSharedFilesTab} />
              </div>
            }
            searchBar={<GlobalSearchTagsFilter />}
          />
        }>
        <Pagination fullWidth className={styles.tabs}>
          {Object.keys(manageTabOption()).map((key) => {
            const config = TAB_CONFIG[key];
            return (
              <Pagination.Item
                onClick={() => setActiveTab(TAB[key])}
                active={activeTab === TAB[key]}
                key={key}>
                {config.name}
              </Pagination.Item>
            );
          })}
        </Pagination>
      </CommonGrid>

      <Component
        key={activeTab}
        useGlobalSearch
        hideStickyHeader
        designV2={true}
        noDataText={'Ooops, no results found'}
        // cardProps={{ onSelect: null }}
        apiConfig={{
          defaultCreatedBy: (isGenericTab && doNotIncludeCreatedBy) ? currentUser.id : undefined,
          defaultBrands: isGenericTab ? currentUser.organization : undefined,
        }}
        {...props}>
        <Routes>
          <Route path={RENDERS_PREVIEWS_ROUTE_V2}>
            <Route path=":renderId" exact element={<RenderDetails />} />
          </Route>
          <Route path={TEMPLATES_ROUTE_V2}>
            <Route path=":roomId" exact element={<TemplatesDetails />} />
          </Route>
          <Route path={SHARED_FILES_ROUTE}>
            <Route path="renders/:renderId" exact element={<RenderDetails />} />
            <Route path="templates/:roomId" exact element={<TemplatesDetails />} />
          </Route>
        </Routes>
      </Component>
    </>
  );
}
